// Copyright © 2023 Move Closer

export enum HeadingFont {
  Default = 'default',
  Alternative = 'alternative',
}
